import React from 'react';
import CusPageContainer from '../../../components/shared/CusPageContainer';
import CusButton from '../../../components/material-ui/CusButton';
import ListBannersTable from './ListBannersTable';
import TimeZone from '../../../components/shared/TimeZone';
import FlexContainer from '../../../components/material-ui/adaptive/FlexContainer';
import useGroupByGroupId from '../../../hooks/site/useGroupByGroupId';
import useEditSliderBanner from '../../../hooks/site/bonus/useEditSliderBanner';
import LoaderContainer from '../../../components/material-ui/loader_container/LoaderContainer';
import CusSwitch from '../../../components/material-ui/CusSwitch';

export default function SliderListBanners() {
  const { group, groupId } = useGroupByGroupId();

  const {
    banners,
    loader,
    onlyUnread,
    filterLang,
    addBanner,
    onBannerDelete,
    setOnlyUnread,
    setFilterLang
  } = useEditSliderBanner({ groupId, type: 'list' });

  return (
    <CusPageContainer title={'Slider banners'} group={group} loader={!group}>
      <LoaderContainer loader={loader} isBox>
        <FlexContainer display={'flex'} gap={2} justifyContent={'space-between'}>
          <CusButton
            text="Add banner"
            variant="outlined"
            boxProps={{ width: 200 }}
            fullWidth
            onClick={addBanner}
          />
          <TimeZone groupId={groupId} />
        </FlexContainer>
        <FlexContainer gap={1} justifyContent={'space-between'}>
          <CusSwitch
            label={'Show only relevant ones'}
            checked={onlyUnread}
            onChange={() => setOnlyUnread((prev) => !prev)}
          />
        </FlexContainer>
        <ListBannersTable
          banners={banners}
          filterLang={filterLang}
          onBannerDelete={onBannerDelete}
          setFilterLang={setFilterLang}
        />
      </LoaderContainer>
    </CusPageContainer>
  );
}
